import { SafetyPlan, SafetyPlanBody } from '@lyrahealth-inc/shared-app-logic/src/models/safetyPlan/SafetyPlan'

import { baseApi, RTKQueryTag } from '../../../data/baseApi'

type GetClientSafetyPlansArgs = {
  patientId: string
}

type CreateSafetyPlanArgs = {
  patientId: string
  body: SafetyPlanBody
  submit: boolean
  originatingEpisodeId?: string
}

type UpdateSafetyPlanArgs = {
  id: string
  versionId: number
  body?: { [K in keyof SafetyPlanBody]: SafetyPlanBody[K] | null }
  submit?: boolean
}

const safetyPlanApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getClientSafetyPlans: builder.query<SafetyPlan[], GetClientSafetyPlansArgs>({
      query: ({ patientId }) => ({
        method: 'get',
        url: '/lt/v1/safetyplans',
        params: { patient_id: patientId },
        showAlert: false,
      }),
      providesTags: [RTKQueryTag.SAFETY_PLAN],
    }),
    createSafetyPlan: builder.mutation<SafetyPlan, CreateSafetyPlanArgs>({
      query: ({ patientId, body, submit, originatingEpisodeId }) => ({
        method: 'post',
        url: '/lt/v1/safetyplans',
        data: { patient_id: patientId, body, submit, originating_episode_id: originatingEpisodeId },
        showAlert: false,
      }),
      onQueryStarted: async (_args, { dispatch, queryFulfilled }) => {
        try {
          const { data: plan } = await queryFulfilled
          dispatch(
            safetyPlanApi.util.updateQueryData('getClientSafetyPlans', { patientId: plan.patient_id }, (plans) => {
              const index = plans.findIndex(({ id }) => id === plan.id)
              if (index === -1) plans.unshift(plan)
              else plans[index] = plan
            }),
          )
        } catch {
          // Save errors are handled by the caller
        }
      },
    }),
    updateSafetyPlan: builder.mutation<SafetyPlan, UpdateSafetyPlanArgs>({
      query: ({ id, versionId, body, submit }) => ({
        method: 'patch',
        url: `/lt/v1/safetyplans/${id}`,
        data: { version_id: versionId, body, submit },
        showAlert: false,
      }),
      onQueryStarted: async (_args, { dispatch, queryFulfilled }) => {
        try {
          const { data: plan } = await queryFulfilled
          dispatch(
            safetyPlanApi.util.updateQueryData('getClientSafetyPlans', { patientId: plan.patient_id }, (plans) => {
              const index = plans.findIndex(({ id }) => id === plan.id)
              if (index === -1) plans.unshift(plan)
              else plans[index] = plan
            }),
          )
        } catch {
          // Save errors are handled by the caller
        }
      },
    }),
  }),
})

export const { useGetClientSafetyPlansQuery, useCreateSafetyPlanMutation, useUpdateSafetyPlanMutation } = safetyPlanApi
export default safetyPlanApi
